import { Badge, borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const MainInfo = styled.div<{ $isTooltip?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: ${props => (props.$isTooltip ? 'fit-content' : '52px')};
  max-width: ${props => (props.$isTooltip ? '100%' : '60%')};
  gap: ${props => (props.$isTooltip ? '5px' : '0')};
`;

export const InsightNameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const InsightName = styled.h4<{ $isTooltip?: boolean }>`
  ${props =>
    props.$isTooltip ? typographyV2.titleSm : typographyV2.titleBase};
`;

export const InfoDetail = styled.div<{ $isTooltip?: boolean }>`
  ${props => (props.$isTooltip ? typographyV2.bodyXs : typographyV2.bodySm)};
  display: flex;
  gap: 4px;
  padding-right: 8px;
  border-right: 1px solid var(--border-default);
`;

export const InfoDetailWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledBadge = styled(Badge)`
  ${Badge.Styled.BadgeTextual} {
    padding: 2px 4px;
    ${borderRadius.r05};
  }
`;

export const Episode = styled.span`
  white-space: nowrap;
  ${typographyV2.bodyXs};
`;

export const Median = styled.span<{ $isBullish: boolean }>`
  color: ${props =>
    props.$isBullish ? 'var(--viz-bullish)' : 'var(--viz-bearish)'};
`;

export const Dot = styled.span`
  color: var(--icon-soft);
`;

export const StarsLabel = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 2px;

  & svg {
    fill: var(--icon-primary);
  }
`;
